var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"treant",style:({ 'max-width': _vm.width })},[_c('div',{staticClass:"tree-container",attrs:{"id":("tree-" + _vm.treeBankId)}})])}
var staticRenderFns = []

export { render, staticRenderFns }